{
  "eyebrow": "Bevestig je abonnement",
  "title": "Bekijk en configureer.",
  "sub": "Je kan facturatiecyclus of abonnement op elk moment aanpassen in je beheerdersdashboard.",
  "yourPlan": "Jouw abonnement",
  "changePlan": "Wijzig abonnement",
  "billing": "Facturatiecyclus",
  "billingMonthLabel": "Maandelijks betalen",
  "billingMonthDesc": "Flexibel. Stop wanneer je wil.",
  "billingYearLabel": "Jaarlijks betalen",
  "billingYearDesc": "15% korting. Eén keer per jaar gefactureerd.",
  "addons": "Add-ons",
  "addon": {
    "ssec": "Sociale zekerheid (check-in/out@work)",
    "ssecDesc": "Alleen België — automatische Dimona-aangifte.",
    "vtt": "Vehicle Track & Trace",
    "vttDesc": "Live GPS voor bedrijfsvoertuigen. +€4 / voertuig / maand.",
    "vehicles": "Voertuigen"
  },
  "employees": {
    "title": "Hoeveel medewerkers?",
    "active": "gebruikers",
    "popular": "Meeste teams kiezen {{n}}"
  },
  "estimate": "Geschatte maandkost",
  "estimateNote": "Exclusief btw. U betaalt voor het aantal gebruikers dat u hier instelt; u kunt dit later aanpassen.",
  "estimateUnavailable": "Prijscatalogus niet beschikbaar. Probeer opnieuw om de laatste prijzen te laden."
}
